import { createSelector } from 'reselect'
import { pendingSelector } from 'api/selectors'

const stateSelector = state => state.nps

export const getAllSurveyAdmin = createSelector(stateSelector, state => state.allAdminSurveys)
export const getActualSurvey = createSelector(stateSelector, state => state.actualSurvey)

export const getSurveyTextAnswer = createSelector(stateSelector, state => state.textAnswers)
export const getSurveyResult = createSelector(stateSelector, state => state.surveyResult)
export const getChartData = createSelector(stateSelector, state => state.chartData)

export const pendingGetAllSurveys = createSelector(pendingSelector, state => state.GET_ALL_SURVEY_BY_COUNTRY_ADMIN)

export const getAllSurveys = createSelector(stateSelector, state => state.allSurveys)

export const getAnswerSendingResult = createSelector(stateSelector, state => state.answersSentSuccessfuly)

export const sendSurveyAnswerPendingSelector = createSelector(
    pendingSelector,
    pending => pending.sendSurveyAnswerProcess
)
export const createNewSurveyPendingSelector = createSelector(
    pendingSelector,
    pending => pending.ADD_NEW_SURVEY_BY_COUNTRY
)

export const createNewSurveyResult = createSelector(stateSelector, state => state.addNewSurveyResult)
export const createNewSurveyError = createSelector(stateSelector, state => state.addNewSurveyError)

export const getCSVData = createSelector(stateSelector, state => state.csv)
